import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleScroll = this.throttle(this.handleScroll.bind(this), 100)
    this.heroSection = document.querySelector('[data-hero-section]')
    this.footer = document.querySelector('footer')

    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll() // Check initial state
  }

  throttle(func, delay) {
    let timeoutId
    let lastExecTime = 0
    return function(...args) {
      const currentTime = Date.now()
      if (currentTime - lastExecTime > delay) {
        func.apply(this, args)
        lastExecTime = currentTime
      } else {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => {
          func.apply(this, args)
          lastExecTime = Date.now()
        }, delay - (currentTime - lastExecTime))
      }
    }
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    if (this.heroSection) {
      const heroRect = this.heroSection.getBoundingClientRect()
      const heroBottom = heroRect.bottom

      let isFooterVisible = false
      if (this.footer) {
        const footerRect = this.footer.getBoundingClientRect()
        isFooterVisible = footerRect.top < window.innerHeight
      }

      // Show banner 50px before hero section is completely out of view
      // Hide banner when footer is visible
      if (heroBottom <= 50 && !isFooterVisible) {
        this.element.classList.remove('hidden')
      } else {
        this.element.classList.add('hidden')
      }
    } else {
      // Fallback if hero section not found
      const scrollPosition = window.scrollY
      const threshold = 600 // Approximate hero height

      if (scrollPosition > threshold) {
        this.element.classList.remove('hidden')
      } else {
        this.element.classList.add('hidden')
      }
    }
  }
}